var map = {
	"./Logo (5).png": 528,
	"./Logo.png": 738,
	"./MAHANERGY.png": 641,
	"./asd.png": 115,
	"./fatoora.png": 259,
	"./imdad.png": 10,
	"./logo (2).png": 441,
	"./logo (3).png": 714,
	"./logo.svg": 692,
	"./logo2.png": 826,
	"./ogo.png": 70,
	"./org.png": 141,
	"./tatweer.png": 13
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 959;